import React from "react";

const Loader = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-white"></div>
    </div>
  );
};

export default Loader;
